import { useQuery } from '@tanstack/react-query';
import { fetcher } from '@/lib/queryClient';
import type { HomeGame } from '@/types/game';
import type { Category } from '@shared/types/schema';

export function useGameData(gameId: number | null) {
  const {
    data: game,
    isLoading: isLoadingGame,
    error: gameError,
  } = useQuery<HomeGame>({
    queryKey: [`/api/games/${gameId}`],
    queryFn: fetcher,
    enabled: !!gameId,
  });

  const {
    isLoading: isLoadingCategories,
    data: categories,
    error: categoriesError,
  } = useQuery<Category[]>({
    queryKey: ['/api/categories'],
    queryFn: fetcher,
  });

  return {
    game,
    categories: categories ?? [],
    isLoading: isLoadingGame || isLoadingCategories,
    error: gameError || categoriesError,
  };
}
